const isValidMongoObjectID = (string = "") => {
  return !!string.match(/^[a-f\d]{24}$/i);
};

export default isValidMongoObjectID;
